var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtvRogersStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7466_3438)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8808 7.44787C13.3966 6.77358 13.7976 5.65967 13.7976 4.51338C13.7976 2.17788 11.6119 0 7.98994 0C5.76664 0 4.00114 0.894041 2.80754 1.91345C3.39248 1.72245 4.22352 1.52893 5.26302 1.52893C8.04253 1.52893 11.3019 3.72174 12.8807 7.44787H12.8808ZM3.11927 8.553C2.60348 9.22642 2.20239 10.3412 2.20239 11.4866C2.20239 13.8221 4.38818 16 8.01015 16C10.2335 16 11.9989 15.1058 13.1917 14.0874C12.6075 14.2783 11.7764 14.4709 10.7369 14.4709C7.95756 14.4709 4.69815 12.2791 3.11927 8.553Z",
    fill: "#EE2722"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.447 3.12011C6.77358 2.60344 5.65879 2.20235 4.51338 2.20235C2.17875 2.20247 0 4.38813 0 8.01098C0 10.2343 0.894041 11.9989 1.91258 13.1915C1.72157 12.6083 1.52893 11.7764 1.52893 10.737C1.52893 7.9584 3.72086 4.69899 7.447 3.12011ZM14.4711 5.26297C14.4711 8.04248 12.2791 11.3019 8.55212 12.8806C9.22554 13.3964 10.3412 13.7984 11.4866 13.7984C13.8221 13.7984 16 11.6127 16 7.99077C16 5.76646 15.105 4.0011 14.0874 2.80837C14.2774 3.39156 14.4711 4.22348 14.4711 5.26297Z",
    fill: "#EE2722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7466_3438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvRogersStore);
export default __webpack_public_path__ + "static/media/ctv_rogers_store.95c4175724d931178beec79857cdd266.svg";
export { ForwardRef as ReactComponent };